import React from 'react';
import { Helmet } from 'react-helmet';
import CloseButton from 'components/CloseButton';
import PageOverlay from 'components/PageOverlay';
import GameFinderWindow from './GameFinderWindow';
import './GameFinderPage.css';

export default function GameFinderPage() {
  return (
    <div className="game-finder-page">
      <PageOverlay>
        <Helmet>
          <title>Game Finder</title>
        </Helmet>
        <h1 className="sr-only">Game Finder</h1>
        <GameFinderWindow />
        <CloseButton url="/" />
      </PageOverlay>
    </div>
  );
}
